export { default } from './easyToken'
export * from './easyToken'
